
export default class

  # key

  constructor: (@key) ->

  set: (value) -> window.localStorage.setItem @key, JSON.stringify value

  get: (defaultValue = null) ->
    json = window.localStorage.getItem @key
    if json == null then return defaultValue
    return JSON.parse json
